enum AdswizzReportType {
  Date = 'DATE',
  Device = 'DEVICE',
  Campaign = 'CAMPAIGN',
  Order = 'ORDER',
  Advertiser = 'ADVERTISER',
  Creative = 'CREATIVE',
  Publisher = 'PUBLISHER',
  Daypart = 'DAYPART',
  Genre = 'GENRE',
  Deals = 'DEALS',
  State = 'STATE',
  Dma = 'DMA',
  County = 'COUNTY',
  Zip = 'ZIP',
  CongressionalDistrict = 'CONGRESSIONAL_DISTRICT',
}

export default AdswizzReportType;
